import { cva } from 'class-variance-authority';

const selectBaseStyles = [
    'absolute',
    'max-h-72',
    'right-0',
    'border',
    'border-t-0',
    'shadow-md',
    'z-20',
    'w-full',
    'overflow-y-auto'
];

const selectStylesSAG = cva([
    ...selectBaseStyles,
    'bg-[#D1FFF2]',
    'border-[#005159]',

    'dark:bg-[#001F39]',
    'dark:border-[#00FFB9]'
]);

const selectStylesSHS = cva([...selectBaseStyles, 'bg-white', 'border-0', 'dark:bg-[#333333]']);

const selectSearchBaseStyles = ['w-full', 'p-3', 'sticky', 'top-0', 'border-b'];

const selectSearchStylesSAG = cva([
    ...selectSearchBaseStyles,
    'bg-[#D1FFF2]',
    'border-[#005159]',

    'dark:bg-[#001F39]',
    'dark:border-[#00FFB9]'
]);

const selectSearchStylesSHS = cva([
    ...selectSearchBaseStyles,
    'bg-white',
    'border-[#333333]',

    'dark:bg-[#333333]',
    'dark:border-[#999999]'
]);

const selectSearchInputBaseStyles = ['w-full', 'mt-2', 'form-input'];

const selectSearchInputStylesSAG = cva([
    ...selectSearchInputBaseStyles,
    'bg-[#EBF7F8]',
    'border-[#4C4C68]',

    'dark:bg-[#262648]',
    'dark:border-[#B3B3BE]',
    'dark:text-white'
]);

const selectSearchInputStylesSHS = cva([
    ...selectSearchInputBaseStyles,
    'bg-[#ededed]',
    'border-[#666666]',

    'dark:bg-[#1a1a1a]',
    'dark:border-[#999999]',
    'dark:text-white'
]);

export {
    selectStylesSAG,
    selectStylesSHS,
    selectSearchStylesSAG,
    selectSearchStylesSHS,
    selectSearchInputStylesSAG,
    selectSearchInputStylesSHS
};
